export const mapTransmission = (type?: string) => {
  switch (type) {
    case 'A':
      return 'Auto';
    case 'M':
      return 'Manual';
    default:
      return 'Other';
  }
};
